import { render, staticRenderFns } from "./sub-image-detail.vue?vue&type=template&id=c88af568&scoped=true&"
import script from "./sub-image-detail.vue?vue&type=script&lang=js&"
export * from "./sub-image-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88af568",
  null
  
)

export default component.exports